import { useEffect } from 'react';

/**
 * Handles the /risk-management route.
 * Navigates to /risk-management/ served by the auth gateway (same-origin).
 */
export default function RiskManagementRedirect() {
  useEffect(() => {
    window.location.replace('/risk-management/');
  }, []);

  return null;
}
